import {GroupMark} from './marktypes';
import {ScopeRole, MarkRole} from './roles';

export default function(spec) {
  var role = spec.role || '';
  return (!role.indexOf('axis') || !role.indexOf('legend'))
    ? role
    : spec.type === GroupMark ? ScopeRole : (role || MarkRole);
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-parser/src/parsers/marks/role.js
// module id = 829
// module chunks = 0